import { useQuery } from '@tanstack/react-query';
import { postRequest } from '../../services/requestService';

export const getTopAssetManagers = async (searchCriteria = {}) => {
  const res = await postRequest(
    '/data/top-asset-managers-report',
    searchCriteria,
    {
      timeout: 0,
      keepAlive: true,
      headers: {
        Connection: 'keep-alive',
      },
    },
  );

  const { data } = res.data;

  return data;
};

export const useGetTopAssetManagers = ({ appliedFilters, isMounted }) =>
  useQuery({
    queryKey: ['topBuyersByKnownAccount', appliedFilters],
    queryFn: () =>
      getTopAssetManagers({
        appliedFilters,
      }),
    enabled: isMounted,
  });
